import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";
import User from "@views/user/User";
import Order from "@views/order/MyOrder";
import Caigou from "@views/caigou/Caigou";
import Tongpei from "@views/caigou/Tongpei";
import Kufang from "@views/caigou/Kufang";
import Huizong from "@views/huizong/Huizong";
import Yihuizong from "@views/huizong/Yihuizong";
import DynamicHome from "@views/home/DynamicHome";
import OrderDetails from "@views/order/OrderDetails";
import OrderhuizongDetails from "@views/order/OrderhuizongDetails";
import ChangePassword from "@views/user/ChangePassword";
import store from "@utils/store/cookie";
 import goods from "@components/goods/goods";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
   {
    path: '/',
    name: 'Home',
	
    component:  DynamicHome, // 统一入口组件
    meta: {  title: "首页",
        keepAlive: true,
        footer: true,
		home: false,
		auth:true,
		auth: true 
		} // 需要登录
  },
  
    {
      path: "goods",
      name: "GoodsClass",
      meta: {
        title: "选品",
        keepAlive: true,
        footer: true,
		home: false,
		auth:true,
        backgroundColor: "#fff",
		roles: ['4']
      },
      component: goods
    },
    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "收藏商品",
        keepAlive: false,
        auth: false,
		  home: false
      },
      component: () => import("@views/shop/GoodsCollection.vue")
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "搜索商品",
        keepAlive: true,
		  home: false,
        backgroundColor: "#fff"
      },
      component: Search
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: true,
        backgroundColor: "#fff",
		  home: false
      },
      component: () => import("@views/shop/news/NewsDetail.vue")
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff",
		  home: false
      },
      component: () => import("@views/shop/news/NewsList.vue")
    },{
      path: "/user",
      name: "User",
      meta: {
        title: "个人中心",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false
      },
      component: User
    },{
      path: "/order",
      name: "Order",
      meta: {
        title: "订单",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false,
		  auth: false,
		  roles: ['4']
      },
      component: Order
    },{
      path: "/caigou",
      name: "Caigou",
      meta: {
        title: "店面采购",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false,
		  auth: false,
		  roles: ['3']
      },
      component: Caigou
    },{
      path: "/tongpei",
      name: "Tongpei",
      meta: {
        title: "统配单",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false,
		  auth: false,
		  roles: ['3']
      },
      component: Tongpei
    },{
      path: "/kufang",
      name: "Kufang",
      meta: {
        title: "库房采购",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false,
		  auth: false,
		  roles: ['3']
      },
      component: Kufang
    },{
      path: "/huizong",
      name: "Huizong",
      meta: {
        title: "未汇总",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false,
		  auth: false,
		  roles: ['15']
      },
      component: Huizong
    },{
      path: "/yihuizong",
      name: "Yihuizong",
      meta: {
        title: "已汇总",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false,
		  auth: false,
		  roles: ['15']
      },
      component: Yihuizong
    }, {
      path: "/OrderDetails",
      name: "OrderDetails",
      meta: {
        title: "订单详情",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false,
		  auth: false
      },
      component: OrderDetails
    },{
      path: "/OrderhuizongDetails",
      name: "OrderhuizongDetails",
      meta: {
        title: "订单详情",
        keepAlive: true,
		footer: true ,
        backgroundColor: "#fff",
		  home: false,
		  auth: false
      },
      component: OrderhuizongDetails
    },{
      path: "/ChangePassword",
      name: "ChangePassword",
      meta: {
        title: "修改密码",
        keepAlive: true,
        auth: false,
		  home: true
      },
      component: ChangePassword
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "商品评分",
        keepAlive: true,
        auth: false,
		  home: false
      },
      component: () => import("@views/shop/EvaluateList.vue")
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "商品评价",
        keepAlive: true,
        auth: false,
		  home: false
      },
      component: () => import("@views/shop/GoodsEvaluate.vue")
    },{
    path: "/caigou/caigoudm/:id",
    name: "caigoudm",
    meta: {
      title: "采购明细",
      keepAlive: false,
	   home: false,
      auth: true
    },
    component: () => import("@views/caigou/Caigoudm")
  },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "促销单品",
        keepAlive: false,
		  home: false
      },
      component: () => import("@views/shop/GoodsPromotion.vue")
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "热门榜单",
        keepAlive: false,
		  home: false
      },
      component: () => import("@views/shop/HotNewGoods.vue")
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "商品详情",
        keepAlive: false,
		  home: false
      },
      component: () => import("@views/shop/GoodsCon.vue")
    },
    {
      path: "/shop/storeList/:gonames?",
      name: "StoreList",
      meta: {
        title: "门店列表",
        keepAlive: false,
		  home: false
      },
      component: () => import("@views/shop/StoreList.vue")
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "购物车",
        keepAlive: true,
        footer: true ,
		auth: false,
		  home: false
      },
      component: ShoppingCart
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "商品列表",
        keepAlive: true,
		auth: false,
		  home: false
      },
      component: GoodsList
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        title: "注册",
        keepAlive: true,
		auth: false,
		  home: false
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Register.vue")
    },
    {
      path: "/change_password",
      name: "ChangePassword",
      meta: {
        title: "修改密码",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: false,
		  home: false
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/ChangePassword.vue")
    },
    {
      path: "/retrieve_password",
      name: "RetrievePassword",
      meta: {
        title: "找回密码",
        keepAlive: true,
		auth: false,
		  home: false
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue")
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: true,
		  home: false
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue")
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true,
		  home: false
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
	//const uid=store.get("uid") || null;
	//const qx=store.get("qx") || null;
	 const userInfo = localStorage.getItem('userInfo'); 
	   
 const user = JSON.parse(userInfo);
	//const user=Vue.prototype.$user;
 console.log(user);
	   
	// if (userInfo) {
   // const user = JSON.parse(userInfo);
    // 进行自动登录或其他初始化操作，例如设置全局状态等。
 //  $store.commit('setUser', user); // 假设使用Vuex来管理状态。
  // console.log(user);
 // }
 
  const { title, backgroundColor, footer, home, auth } = to.meta;
  
  
  console.log(to.name, form.name,to.fullPath);
  if (auth === true && !user) {
    if (form.name === "Login") return;
    return toLogin(true, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "饭小隐";
  	 
 
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

export default router;
